import { useMemo } from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { doorIcon, layersIcon, squareMetersIcon } from '../config/icons';

export type ApartmentInfoProps = {
  t: (key: string, options?: any) => string;
  apartmentLanding: any;
};

export function ApartmentInfo({ t, apartmentLanding }: ApartmentInfoProps) {
  const [ifOneOnly, rooms, livingArea, floor] = useMemo(() => {
    const rooms = !!apartmentLanding?.rooms ? apartmentLanding.rooms : false;
    const livingArea = !!apartmentLanding?.livingArea ? apartmentLanding.livingArea : false;
    const floor = apartmentLanding?.minFloor || apartmentLanding?.maxFloor || false;
    const ifOneOnly = [rooms, livingArea, floor].filter((item) => !!item).length == 1;
    return [ifOneOnly, rooms, livingArea, floor];
  }, [apartmentLanding]);

  if (!apartmentLanding) return null;

  return (
    <Stack spacing={2}>
      <Divider style={{ width: '100%' }} />
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent={ifOneOnly ? 'flex-start' : 'space-evenly'}
        spacing={1}
        sx={{ width: '100%' }}
      >
        {rooms && (
          <Stack direction="column" alignItems="center" spacing={1}>
            {doorIcon}
            <Typography variant="body1" fontWeight="600" textAlign="center">
              {t('labels.lowerCaseRooms', { v: rooms })}
            </Typography>
          </Stack>
        )}
        {livingArea && (
          <Stack direction="column" alignItems="center" spacing={1}>
            {squareMetersIcon}
            <Typography variant="body1" fontWeight="600" textAlign="center">
              {t('labels.fromM2', { v: livingArea })}
            </Typography>
          </Stack>
        )}
        {floor && (
          <Stack direction="column" alignItems="center" spacing={1}>
            {layersIcon}
            <Typography variant="body1" fontWeight="600" textAlign="center">
              {t('labels.floor', { v: floor })}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
